/** Persisted theme preference. `light` keeps the mixed (dark sidenav) look for existing users. */
export type ThemeMode = 'light' | 'light-full' | 'dark';

/** True when the app canvas uses the dark MUI theme. */
export function isDarkThemeMode(mode: ThemeMode): boolean {
  return mode === 'dark';
}

/**
 * Maps app theme mode to the binary light/dark value expected by external surfaces
 * (e.g. the video editor), which do not understand `light-full`.
 */
export function toBinaryThemeMode(mode: ThemeMode): 'light' | 'dark' {
  return mode === 'dark' ? 'dark' : 'light';
}

/**
 * Returns the initial theme mode when no persisted value exists.
 * Seeds from the OS color-scheme preference once at store creation.
 */
export function getInitialThemeMode(): ThemeMode {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}
